<template>
    <ImportComponent 
        :rows="excelLeadsList"
        :columns="tableColumns"
        :idField="idField"
        :loader="loader"
        @showLoader="showLoader"
        @hideLoader="hideLoader"  
        :excel_file="excel_file"  
        :filePath="filePath"
        @file-changed="handleFileChange"
        @displayExcelData="displayExcelData"
        @handleSubmit="importLeadsExcel" 
        @handleReset="handleReset" 
        @downloadExcelTemplate="downloadExcelTemplate"
    />
</template>

<script>
import axios from "axios";
import { defineComponent, ref, computed } from 'vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import ImportComponent from '@/components/ImportComponent.vue';

export default defineComponent({
    name: 'Import_Leads',
    components:{
        ImportComponent
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('none');
        const companyID = computed(()=> store.state.userData.company_id);
        const tableColumns = ref([
            {label: "Name", key:"name"},
            {label: "Phone No", key:"phone_number"},
            {label: "Email", key: "email"},
            {label: "Designation", key:"designation"},
            {label: "Company", key:"company_name"},
            {label: "Address", key:"address"},
            {label: "Town", key:"town"},
            {label: "Status", key:"status"},
            {label: "Rating", key:"rating"},
        ])
        const excelLeadsList = ref([]);
        const idField = 'lead_id';
        const excel_file = ref('');
        const filePath = ref('');

        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        } 

        const handleFileChange = (fileData) => {
            filePath.value = fileData.filePath;
            excel_file.value = fileData.file;

        };

        const displayExcelData = () =>{
            showLoader();
            if(excel_file.value == ""){
                toast.error("No File Selected")
                hideLoader();
            }else{
                let formData = new FormData()
                formData.append("leads_excel", excel_file.value) 
                formData.append("company", companyID.value)

                axios.post("api/v1/display-marketing-leads-import-excel/", formData)
                .then((response)=>{
                    if(response.data.msg){
                        toast.error(response.data.msg);
                    }else{
                        excelLeadsList.value = response.data.leads;
                    }           
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideLoader();
                })
            }
        };
        const importLeadsExcel = () =>{
            showLoader();
            if(!excelLeadsList.value.length){
                toast.error("Please Import Excel Template")
                hideLoader();
            }
            else{
                let formData = new FormData()
                formData.append("leads_excel", excel_file.value)
                formData.append("company", companyID.value)

                axios.post("api/v1/import-marketing-leads-excel/", formData)
                .then((response)=>{
                    if(response.data == "Success"){
                        toast.success("Leads Imported Succesfully")
                        handleReset();
                        excelLeadsList.value = [];
                        excel_file.value = "";
                    }else{
                        toast.error(response.data) 
                    }
                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    toast.error(error.message);
                })
                .finally(()=>{
                    hideLoader();
                })
            }
                
        };
        const downloadExcelTemplate = () =>{
            showLoader(); 
            let formData = {

            }
            axios.post("api/v1/download-marketing-leads-import-excel/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Leads_Import.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const handleReset = () =>{
            excelLeadsList.value = [];
            filePath.value = "";
            excel_file.value = "";
        }

        return{
            tableColumns, excelLeadsList, idField, loader, showLoader, hideLoader, excel_file, filePath, displayExcelData, handleFileChange,
            handleReset,importLeadsExcel,downloadExcelTemplate
        }
    }
})
</script>